import {
  Clock,
  Download,
  Link,
  Lock,
  Mail,
  Printer,
  Share2
} from "lucide-react";

import { TableExportFormat } from "@/api/form";

import TableActionModal, {
  TableActionOption
} from "@/pages/form/final/table-action-modal";
import { tableExportOptions } from "@/pages/form/final/table-export-options";

export type TableShareAction =
  | "link-internal"
  | "link-permanent"
  | "link-expiring"
  | "link-multi-use"
  | "system-share"
  | "email-table"
  | "email-attachment"
  | "direct-print"
  | `export-${TableExportFormat}`;

interface TableShareModalProps {
  isOpen: boolean;
  isLoading: boolean;
  tableCount: number;
  onOpenChange: (open: boolean) => void;
  onSelect: (action: TableShareAction) => void;
}

const linkShareOptions: TableActionOption<TableShareAction>[] = [
  {
    value: "link-permanent",
    title: "لینک دائمی",
    subtitle: "ایجاد لینک پایدار برای مشاهده امن جدول",
    icon: Link,
    section: "اشتراک گذاری با لینک"
  },
  {
    value: "link-expiring",
    title: "لینک زمان دار",
    subtitle: "ایجاد لینک با اعتبار زمانی مشخص",
    icon: Clock,
    section: "اشتراک گذاری با لینک"
  },
  {
    value: "link-multi-use",
    title: "لینک چندبار مصرف محدود",
    subtitle: "ایجاد لینک با تعداد دفعات استفاده قابل کنترل",
    icon: Lock,
    section: "اشتراک گذاری با لینک"
  },
  {
    value: "link-internal",
    title: "اشتراک گذاری با لینک داخلی",
    subtitle: "نمایش فقط برای کاربران احراز هویت شده و دارای دسترسی",
    icon: Link,
    section: "اشتراک گذاری با لینک"
  }
];

const fileShareOptions: TableActionOption<TableShareAction>[] =
  tableExportOptions.map((option) => ({
    ...option,
    value: `export-${option.value}` as TableShareAction,
    section: "ارسال فایل خروجی"
  }));

const deliveryOptions: TableActionOption<TableShareAction>[] = [
  {
    value: "system-share",
    title: "اشتراک گذاری دیگر",
    subtitle: "استفاده از ابزار اشتراک گذاری سیستم عامل",
    icon: Share2,
    section: "ارسال و انتشار"
  },
  {
    value: "direct-print",
    title: "چاپ مستقیم",
    subtitle: "ارسال مستقیم جدول برای چاپ",
    icon: Printer,
    section: "ارسال و انتشار"
  },
  {
    value: "email-table",
    title: "ارسال جدول از طریق ایمیل",
    subtitle: "ارسال محتوای جدول در متن ایمیل",
    icon: Mail,
    section: "ارسال و انتشار"
  },
  {
    value: "email-attachment",
    title: "ارسال فایل ضمیمه به ایمیل",
    subtitle: "ارسال خروجی جدول به صورت فایل قابل ضمیمه",
    icon: Download,
    section: "ارسال و انتشار"
  }
];

const tableShareOptions: TableActionOption<TableShareAction>[] = [
  ...linkShareOptions,
  ...fileShareOptions,
  ...deliveryOptions
];

const TableShareModal: React.FC<TableShareModalProps> = ({
  isOpen,
  isLoading,
  tableCount,
  onOpenChange,
  onSelect
}) => {
  return (
    <TableActionModal
      isOpen={isOpen}
      isLoading={isLoading}
      tableCount={tableCount}
      onOpenChange={onOpenChange}
      onSelect={onSelect}
      title="انتخاب روش اشتراک گذاری"
      description={`${tableCount} جدول برای اشتراک گذاری آماده است. لطفا روش مورد نظر را انتخاب کنید.`}
      footerLabel="اشتراک گذاری جدول"
      loadingText="در حال آماده سازی عملیات اشتراک گذاری..."
      options={tableShareOptions}
      headerIcon={Share2}
    />
  );
};

export default TableShareModal;
